import { z } from 'zod';
import { moneySchema } from '../money';
import { costCenterSchema } from '../time-tracking/master-data.schema';

/**
 * Position/Rolle mit Verrechnungs-Stundensatz (ADR 0016). Stammdaten: füllt den
 * Mitarbeiter-Satz vor und gliedert die Stunden im Controlling. Die Kostenstelle
 * (§ Zeiterfassung) hängt an der Position statt am einzelnen Mitarbeiter — beide
 * Felder bildeten vorher dieselbe Auswahl doppelt ab.
 */
export const createPositionSchema = z.object({
  name: z.string().trim().min(1).max(120),
  hourlyRate: moneySchema,
  /** Kostenstelle, die Mitarbeiter mit dieser Position auf Zeiteinträge übernehmen. */
  costCenter: costCenterSchema.nullable().optional(),
  isActive: z.boolean().default(true),
});
export type CreatePositionInput = z.infer<typeof createPositionSchema>;

export const updatePositionSchema = createPositionSchema.partial();
export type UpdatePositionInput = z.infer<typeof updatePositionSchema>;

export const positionResponseSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  name: z.string(),
  hourlyRate: moneySchema,
  costCenter: costCenterSchema.nullable(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type PositionResponse = z.infer<typeof positionResponseSchema>;
